import React, { useState, useEffect, useRef } from "react";
import Logo from "../assets/logo.jpg";
import iCart from "../assets/i-cart.svg";
import { Link, useNavigate, useLocation } from "react-router-dom"; // Import useLocation
import { Avatar, Dropdown, Navbar } from "flowbite-react";
import ImgAvatar from "../assets/avatar2.png";
import { IoMdHome } from "react-icons/io";
import { FaThList } from "react-icons/fa";
import { MdSupportAgent } from "react-icons/md";
import { CgProfile } from "react-icons/cg";
import { FiX, FiMenu } from "react-icons/fi"; // Import icons for toggle

const NavBar = ({ cartItemCount , setIsDpEdited , isDpEdited}) => {
  const navigate = useNavigate();
  const location = useLocation(); // Get current location
  const token = localStorage.getItem("token");
  const [profileData, setProfileData] = useState();
  const [dropdownOpen, setDropdownOpen] = useState(false); // State for dropdown toggle
  const apiBase = process.env.REACT_APP_API;
  const dropdownRef = useRef(null);

  useEffect(() => {
    const fetchProfileData = async () => {
      const token = localStorage.getItem("token");
      if (!token) {
        return;
      }

      try {
        const response = await fetch(`${apiBase}/profile`, {
          method: "POST",
          headers: {
            Authorization: `${token}`,
            "Content-Type": "application/json",
          },
        });
        const data = await response.json();
        setProfileData(data);
        setIsDpEdited(false);
      } catch (err) {
        console.log("Failed to fetch profile data.");
      }
    };

    fetchProfileData();
  }, [token, isDpEdited]);

  // Toggle dropdown on click
  const toggleDropdown = () => setDropdownOpen(!dropdownOpen);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div className="fixed z-50 w-full top-0 left-0 bg-white bg-opacity-85 backdrop-blur-sm">
      <Navbar
        fluid
        rounded
        className=" bg-opacity-0 backdrccop-blur-sm lg:mx-10"
      >
        <Navbar.Brand href="/">
          <Link to="" className="flex items-center space-x-3 mb-2 sm:mb-0">
            <img src={Logo} className="size-10 rounded-full" alt="Logo" />
            <span className="self-center text-myBlack text-lg sm:text-2xl font-semibold whitespace-nowrap">
              <span className="font-bold">AL</span>Guidance.lk
            </span>
          </Link>
        </Navbar.Brand>
        <div className="flex md:order-2 items-center pt-">
          <Dropdown
            className="bg-white shadow-lg backdrop-blur-lg px-4"
            arrowIcon={false}
            inline
            label={
              token ? (
                <img
                  src={profileData?.profile?.[0]?.dp}
                  alt=""
                  className="size-10 rounded-full border m-2"
                />
              ) : (
                ""
              )
            }
          >
            <div className="">
              <Dropdown.Header>
                <span className="block text-lg font-bold text-myBlue">
                  {profileData?.profile?.[0]?.first_name || "Guest"}
                </span>
                <span className="block truncate opacity-50 text-base font-medium">
                  {profileData?.profile?.[0]?.phone_number || "No phone number"}
                </span>
              </Dropdown.Header>

              <Link to="/profile">
                <Dropdown.Item className="font-semibold text-base">
                  Profile
                </Dropdown.Item>
              </Link>
              <Dropdown.Divider />

              {profileData?.profile?.[0]?.type == "admin" && (
                <Link to={"/admin"}>
                <Dropdown.Item
                  className="font-semibold text-base"
                >
                  DashBoard
                </Dropdown.Item>
                </Link>
              )}

              <Dropdown.Item
                onClick={() => {
                  localStorage.removeItem("token");
                  navigate("/");
                }}
                className="font-semibold text-base"
              >
                Log out
              </Dropdown.Item>
            </div>
          </Dropdown>
          <Link to="/cart" className="flex flex-row -space-x-2 items-start">
            <img src={iCart} alt="" className="size-6" />
            <p className="bg-myBlue size-5 text-center items-center flex justify-center font-bold text-white rounded-full -translate-y-2">
              {cartItemCount}
            </p>
          </Link>
          <button
            onClick={toggleDropdown}
            className="md:hidden ml-4 focus:outline-none"
          >
            {dropdownOpen ? <FiX size={24} /> : <FiMenu size={24} />}
          </button>
        </div>
        <Navbar.Collapse
          className={`pt-4 ${dropdownOpen ? "block" : "hidden"} lg:flex`}
          ref={dropdownRef}
        >
          {["/", "/courses", "/support", "/profile"].map((path, index) => (
            <Link
              key={index}
              to={path}
              onClick={() => setDropdownOpen(false)} // Close dropdown on link click
              className={`pl-2 pb-3 text-xl font-bold ${
                location.pathname === path
                  ? "text-myBlue underline" // Highlight selected link
                  : "text-myBlack hover:underline hover:text-myBlue"
              }`}
            >
              {index === 0
                ? "Home"
                : index === 1
                ? "Courses"
                : index === 2
                ? "Support"
                : "Profile"}
            </Link>
          ))}
          {!token && (
            <div className="flex flex-row space-x-3 justify-center">
              <Link to="/login">
                <button
                  type="button"
                  className="text-myBlack border hover:bg-gray-200 focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 lg:px-8 py-2.5 text-center flex justify-center items-center"
                  onClick={() => setDropdownOpen(false)}
                >
                  Log in
                </button>
              </Link>
              <Link to="/register">
                <button
                  type="button"
                  className="text-white bg-myBlue hover:bg-myPurple focus:ring-1 focus:outline-none focus:ring-primary-300 font-medium rounded-lg text-sm px-5 lg:px-8 py-2.5 text-center flex justify-center items-center"
                  onClick={() => setDropdownOpen(false)}
                >
                  Register
                </button>
              </Link>
            </div>
          )}
        </Navbar.Collapse>
      </Navbar>
    </div>
  );
};

export default NavBar;
